export const environment = {
  production: false,
  url: 'https://devapi.aidefinance.io/',
  secretKey:
    'MIICXAIBAAKBgQDfmlc2EgrdhvakQApmLCDOgP0nNERInBheMh7J/r5aU8PUAIpGXET/8',
  odoo: {
    url: 'https://backoffice.kreador.io/jsonrpc',
    db: 'developer_backoffice_db',
    login: 2,
    username: 'info@kelubaemeka.me',
    password: 'admin',
  },
};
  